export default __webpack_public_path__ + "static/media/Eagles.ec177b69.png";